import Home from '@/pages/Home'
import People from '@/pages/People'
import News from '@/pages/News'
import ArchiveCollections from '@/pages/ArchiveCollections'
import ArchivePeople from '@/pages/ArchivePeople'
import ArchiveNews from '@/pages/ArchiveNews'
import ArchiveProducts from '@/pages/ArchiveProducts'
import Product from '@/pages/Product'
import ProductShop from '@/pages/ProductShop'
import Shop from '@/pages/Shop'
import Contact from '@/pages/Contact'
import About from '@/pages/About'
import PageBuilder from '@/pages/PageBuilder'
import Simple from '@/pages/Simple'
import Editorial from '@/pages/Editorial'
import NotFound from '@/pages/NotFound'
import EditorialSEO from '@/pages/EditorialSEO'

export default (routing, lang) => [
  {
    key: 0,
    path: `/${lang}`,
    exact: true,
    render: () => <Home stub={routing.find((r) => r.cpt === 'homepage')?.slug} />,
  },
  {
    key: 1,
    path: routing.map((route) => {
      if (route.cpt === 'about') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    render: () => <About />,
  },
  {
    key: 2,
    path: routing.map((route) => {
      if (route.cpt === 'page_builder') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    render: () => <PageBuilder />,
  },
  {
    key: 3,
    path: `/${lang}${routing.find((r) => r.cpt === 'people')?.slug}`,
    render: () => <People cpt="people" />,
  },
  {
    key: 4,
    path: routing.map((route) => {
      if (route.cpt === 'archive_peoples') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    render: () => <ArchivePeople cpt="people" stub={routing.find((r) => r.cpt === 'archive_peoples')?.slug} />,
  },
  {
    key: 5,
    path: routing.map((route) => {
      if (route.cpt === 'collections') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    render: () => <ArchiveCollections cpt="_cta_collection" stub={routing.find((r) => r.cpt === 'collections')?.slug} />,
  },
  {
    key: 6,
    path: routing.map((route) => {
      if (route.cpt === 'post') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    render: () => <News cpt="posts" />,
  },
  {
    key: 7,
    path: routing.map((route) => {
      if (route.cpt === 'archive_news') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    render: () => <ArchiveNews cpt="posts" stub={routing.find((r) => r.cpt === 'archive_news')?.slug} />,
  },
  {
    key: 8,
    path: `/${lang}${routing.find((r) => r.cpt === 'product')?.slug}`,
    render: () => <Product cpt="product" />,
    transition: 'slideUp',
  },
  {
    key: 9,
    path: routing.map((route) => {
      if (route.cpt === '_cta_collection') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    render: () => <ArchiveProducts cpt="_cta_collection" stub={routing.find((r) => r.cpt === '_cta_collection')?.slug} />,
  },
  {
    key: 10,
    path: `/${lang}shop/:stub`,
    render: () => <ProductShop />,
    transition: 'slideUp',
  },
  {
    key: 11,
    path: routing.map((route) => {
      if (route.cpt === 'online_shop') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    render: () => <Shop stub={routing.find((r) => r.cpt === 'online_shop')?.slug} />,
  },
  {
    key: 12,
    path: routing.map((route) => {
      if (route.cpt === 'contact') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    render: () => <Contact stub={routing.find((r) => r.cpt === 'contact')?.slug} />,
  },
  {
    key: 13,
    path: routing.map((route) => {
      if (route.cpt === 'simple') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    render: () => <Simple />,
  },
  {
    key: 14,
    path: routing.map((route) => {
      if (route.cpt === 'editorial') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    render: () => <Editorial />,
  },
  {
    key: 15,
    path: routing.map((route) => {
      if (route.cpt === 'editorial_seo') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    render: () => <EditorialSEO />,
  },
  {
    key: 999,
    component: NotFound,
  },
]
